export default __webpack_public_path__ + "5f776e1bfebedb24d6179b971a5e32d4.png";